import type { Vec3 } from '../../scene/spawn'

export interface FlyInput {
  leftX: number
  leftY: number
  rightX: number
  rightY: number
}

export interface FlyConfig {
  moveSpeed: number
  turnSpeed: number
  deadzone: number
  vertical: boolean
}

export const DEFAULT_FLY: FlyConfig = {
  moveSpeed: 2,
  turnSpeed: 1.6,
  deadzone: 0.15,
  vertical: true,
}

export function applyDeadzone(v: number, dz: number): number {
  return Math.abs(v) < dz ? 0 : v
}

export function computeFly(
  input: FlyInput,
  headYaw: number,
  dt: number,
  cfg: FlyConfig,
): { dPos: Vec3; dYaw: number } {
  const forward = applyDeadzone(-input.leftY, cfg.deadzone)
  const strafe = applyDeadzone(input.rightX, cfg.deadzone)
  const lift = cfg.vertical ? applyDeadzone(-input.rightY, cfg.deadzone) : 0

  const sin = Math.sin(headYaw)
  const cos = Math.cos(headYaw)
  const move = cfg.moveSpeed * dt

  const dPos: Vec3 = [
    (-sin * forward + cos * strafe) * move,
    lift * move,
    (-cos * forward - sin * strafe) * move,
  ]
  const dYaw = -applyDeadzone(input.leftX, cfg.deadzone) * cfg.turnSpeed * dt
  return { dPos, dYaw }
}
